import { ProfileInfoFieldType } from '../../../Widget'
import {
  USER_PROFILE_INFO_BANK_NAME_FIELD_NAME,
  USER_PROFILE_INFO_BIC_FIELD_NAME,
  USER_PROFILE_INFO_DEPOSIT_FIELD_NAME,
  USER_PROFILE_INFO_IBAN_FIELD_NAME,
  USER_PROFILE_INFO_OPEN_AMOUNT_FIELD_NAME,
  USER_PROFILE_INFO_PAYMENT_TYPE_FIELD_NAME,
} from '../UserProfileWidget.constants'

export const FINANCIAL_DETAILS_FIELDS = [
  {
    labelKey: 'Widget.InfoIbanLabelKey',
    maxLength: 34,
    name: USER_PROFILE_INFO_IBAN_FIELD_NAME,
    placeholderKey: 'Widget.InfoIbanPlaceholderKey',
    type: ProfileInfoFieldType.IBAN,
  },
  {
    labelKey: 'Widget.InfoBicLabelKey',
    maxLength: 11,
    name: USER_PROFILE_INFO_BIC_FIELD_NAME,
    placeholderKey: 'Widget.InfoBicPlaceholderKey',
    type: ProfileInfoFieldType.BIC,
  },
  {
    labelKey: 'Widget.InfoBankNameLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_BANK_NAME_FIELD_NAME,
    placeholderKey: 'Widget.InfoBankNamePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoPaymentMethodLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_PAYMENT_TYPE_FIELD_NAME,
    placeholderKey: 'Widget.InfoPaymentMethodPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoOutstandingAmountLabelKey',
    name: USER_PROFILE_INFO_OPEN_AMOUNT_FIELD_NAME,
    placeholderKey: 'Widget.InfoOutstandingAmountPlaceholderKey',
    type: ProfileInfoFieldType.CURRENCY,
  },
  {
    labelKey: 'Widget.InfoDepositLabelKey',
    name: USER_PROFILE_INFO_DEPOSIT_FIELD_NAME,
    placeholderKey: 'Widget.InfoDepositPlaceholderKey',
    type: ProfileInfoFieldType.CURRENCY,
  },
]
